module.exports = __webpack_public_path__ + "static/media/icon_ab.d0289dc0.png";